import PaginateModel from "@/model/paginate";
import api from "./api";
import Product, { ProductDTO, SaleBoom } from "@/model/product";
import store from "@/store";

interface ProductList {
  list: Product[];
  paginate: any;
}

class ProductApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async getAll(query): Promise<ProductList> {
    const response = await this.getHttp().get<any>("products", {
      params: query,
    });
    const list: Product[] = [];
    const result = response.data.data;
    const customerInfo = store.getters["Auth/getCustomerUser"];
    const customerPriceCode = customerInfo
      ? customerInfo.m_cart_customer.industry_code
      : null;

    result.data.map((item: ProductDTO) => {
      const product = new Product(item);
      product.setCustomerPrice(customerPriceCode);
      list.push(product);
    });
    // const paginate = new PaginateModel(response.data.pagination);
    const paginate = new PaginateModel({
      page: result.pagination.current_page,
      pageCount: result.pagination.last_pages,
      start: result.pagination.current_page,
      end: result.pagination.last_pages,
      count: result.pagination.total,
    });
    return {
      list: list,
      paginate: paginate,
    };
  }
  async getDetail(id): Promise<Product> {
    const response = await this.getHttp().get<any>(`products/${id}`);
    const customerInfo = store.getters["Auth/getCustomerUser"];
    const customerPriceCode = customerInfo
      ? customerInfo.m_cart_customer.industry_code
      : null;

    const product = new Product(response.data.data);
    product.setCustomerPrice(customerPriceCode);
    return product;
  }

  async getMasterProduct(id): Promise<any> {
    const response = await this.getHttp().get<any>(`master-products/${id}`);
    return response.data;
  }

  async getMasterProducts(query: any): Promise<any> {
    const response = await this.getHttp().get<any>(`master-products`,{
      params: query,
      data: {
        notLoading: true,
      },
    });
    return response.data;
  }

  async addNew(data): Promise<Product> {
    const response = await this.getHttp().post<any>(`products`, data);
    return response.data;
  }

  async delete(id): Promise<any> {
    const response = await this.getHttp().delete<any>(`products/${id}`);
    return response.data;
  }

  async edit(id, data: Product): Promise<any> {
    const response = await this.getHttp().put<any>(`products/${id}`, data);
    return response.data;
  }

  async updateOrder(data: any): Promise<any> {
    const response = await this.getHttp().put<any>(`products/update-order`, data);
    return response.data;
  }

  async getSaleBom(id): Promise<SaleBoom[]> {
    const customerInfo = store.getters["Auth/getCustomerUser"];
    const customerPriceCode = customerInfo
      ? customerInfo.m_cart_customer.industry_code
      : null;
    const response = await this.getHttp().get<any>(`sale-bom-products/${id}`, {
      data: {
        notLoading: true,
      },
    });
    const list: SaleBoom[] = [];
    const result = response.data;

    result.data.map((item: any) => {
      const sale = new SaleBoom(item);
      customerPriceCode && sale.setCustomerPrice(customerPriceCode);
      list.push(sale);
    });

    return list;
  }
  async getSaleBoms(query: any): Promise<SaleBoom[]> {
    const customerInfo = store.getters["Auth/getCustomerUser"];
    const customerPriceCode = customerInfo
      ? customerInfo.m_cart_customer.industry_code
      : null;
    const response = await this.getHttp().get<any>(`sale-bom-products`, {
      params: query,
      data: {
        notLoading: true,
      },
    });
    const list: SaleBoom[] = [];
    const result = response.data;
    result.data.map((item: any) => {
      const sale = new SaleBoom(item);
      customerPriceCode && sale.setCustomerPrice(customerPriceCode);
      list.push(sale);
    });

    return list;
  }
}
export default new ProductApi();
